import Vue from '@/main'
import store from "@/store/store.js"
import chatContact from "@/http/requests/chatContact"
import { getCurrentTenant, decodeFromBase64, formatRouteTenantPath, filterChat, getUserDepartment } from '@/utils'
import router from '@/router'
import customerChats from "@/http/requests/customerChats";
import { ChatTicketService } from "@/db/chatTicket_service";

export default {
  async fetch({commit}, {
    instanceIds,
    finishedTickets = undefined,
    searchQuery = undefined,
    allUsers = undefined,
    inbox = false,
    paginationPage = 1,
    paginationLimit = 10,
    concatResults = false,
    inboxDepartment = null,
    importChat = false,
    newChat = false,
    isCampaign = null,
    groupIds = [],
    userId = undefined
  }) {
    return new Promise((resolve, reject) => {
      chatContact.fetch(
        instanceIds,
        finishedTickets,
        searchQuery,
        allUsers,
        paginationPage,
        paginationLimit,
        undefined,
        inbox,
        inboxDepartment,
        isCampaign,
        groupIds,
        userId
      ).then(response => {
        commit('SET_CHAT_CONTACTS', {
          concatResults,
          items: filterChat(origin, response.data.data.chatTickets.items)
        })
        if (importChat) {
          const ctService = new ChatTicketService();
          ctService.insert(response.data.data.chatTickets.items)
          if (!newChat) {
            response.data.data.chatTickets.items.forEach(item => {
              customerChats.fetch(item.instance_id, item.customer_id)
            })
          }
        }
        resolve(response)
      })
          .catch((error) => {
            reject(error)
          })
    })
  },
  infos({commit}, chatContactId) {
    return new Promise((resolve, reject) => {
      chatContact.infos(chatContactId).then(response => {
        commit('SET_CHAT_CONTACT_INFOS', response.data.data.customerInfos)
        resolve(response)
      })
          .catch((error) => {
            reject(error)
          })
    })
  },
  chatTicketByUserId({commit}, data) {
    return new Promise((resolve, reject) => {
      chatContact.chatTicketByUserId(data)
        .then(response => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  infosChat({commit}, chatTicketId) {
    return new Promise((resolve, reject) => {
      chatContact.infosChat(chatTicketId)
        .then(response => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  resetCustomerUnseenMsgs({commit}, {customerId = null, instanceId = null}) {
    return new Promise((resolve, reject) => {
      store.dispatch('setShowLoadingOverlay', false)
      chatContact.resetCustomerUnseenMsgs(customerId, instanceId).then((response) => {
        commit('RESET_UNSEEN_MESSAGE', customerId)
        store.dispatch('setShowLoadingOverlay', true)
        resolve(response)
      }).catch((error) => {
        store.dispatch('setShowLoadingOverlay', true)
        reject(error)
      })
    })
  },
  changeSelectedCustomer({commit}, {customerId, instanceId = null}) {
    commit('CHANGE_SELECTED_CUSTOMER', {customerId, instanceId})
    return Promise.resolve();
  },
  fetchOldCustomerChats({commit}, {customerId, instanceId, maxId, limit = 20}) {
    return new Promise((resolve, reject) => {
      chatContact.fetchOldCustomerChats(customerId, instanceId, maxId, limit).then(response => {
        const customerChats = response.data.data.oldCustomerChats.reverse();

        commit('PREPEND_SELECTED_CUSTOMER_CHATS', {customerId, customerChats})
        resolve(customerChats)
      })
          .catch((error) => {
            reject(error)
          })
    })
  },
  fetchCustomerChats(
      {commit, state},
      {
        customerId = null,
        instanceId = null,
        unseenMsg = true,
        finishedTickets = false,
        keepTempMessage = false,
        addedCustomerChat = null,
        allUsers = false,
        inbox = false
      }
  ) {
    return new Promise((resolve, reject) => {
      // Remove the ref temp message
      if (addedCustomerChat !== null) {
        const tempMessagesToRemove = state.selectedCustomerChats.chats.filter(chat => {
          if (chat.is_temp && parseInt((chat.id).split('-temp')) <= addedCustomerChat.id) {
            return chat
          }
        })

        if (tempMessagesToRemove.length > 0) {
          tempMessagesToRemove.forEach((value) => {
            commit('REMOVE_TEMPORARILY_MESSAGE', {tempMessageToRemove: value})
          })
        }
      }

      const totalLoadedMessagesQtd = store.state.chatContact.selectedCustomerChats.chats.length
      chatContact.fetchCustomerChats(customerId, instanceId, finishedTickets, allUsers, inbox).then(response => {
        const customerChats = response.data.data.customerChats

        let tempMessages = [];

        if (keepTempMessage) {
          tempMessages = state.selectedCustomerChats.chats.filter(chat => chat.is_temp)
        }

        const messagesQtd = customerChats.length
        const limit = totalLoadedMessagesQtd - messagesQtd
        if (limit > 0 && totalLoadedMessagesQtd > 0 && customerChats[0] && customerChats[0].id) {
          const chat = customerChats[0]

          store.dispatch('setShowLoadingOverlay', false);
          chatContact.fetchOldCustomerChats(customerId, instanceId, chat.id, limit).then(response => {
            const oldCustomerChats = response.data.data.oldCustomerChats.reverse();

            commit('SET_SELECTED_CUSTOMER_CHATS', {customerId, customerChats})
            commit('PREPEND_SELECTED_CUSTOMER_CHATS', {
              customerId,
              customerChats: oldCustomerChats
            })

            if (keepTempMessage) {
              /**
               * Adds the message below the last message to gives the user the "message sent instantly" impression,
               * even though the message was not completely sent yet
               */
              commit('APPEND_LAST_SENT_MESSAGE_TEMPORARILY', {customerId, tempMessages})
            }

            if (customerChats.length > 0) {
              const customerLastChat = customerChats[customerChats.length - 1]

              if (unseenMsg) {
                store.dispatch('chatContact/resetCustomerUnseenMsgs', {customerId, instanceId})
              }

              commit('CHANGE_CONTACT_LAST_MESSAGE', {
                id: customerLastChat.id,
                type: customerLastChat.type, // Sent by attendant
                sent_at: customerLastChat.sent_at,
                message: customerLastChat.message,
                tag_type: customerLastChat.tag_type,
                document_name: customerLastChat.document_name,
                document_mimetype: customerLastChat.document_mimetype,
              })
            }

            resolve(customerChats)
            return;
          }).catch((error) => {
            console.log(error)
          })
        } else {
          commit('SET_SELECTED_CUSTOMER_CHATS', {customerId, customerChats})

          if (keepTempMessage) {
            /**
             * Adds the message below the last message to gives the user the "message sent instantly" impression,
             * even though the message was not completely sent yet
             */
            commit('APPEND_LAST_SENT_MESSAGE_TEMPORARILY', {customerId, tempMessages})
          }

          if (customerChats.length > 0) {
            const customerLastChat = customerChats[customerChats.length - 1]

            if (unseenMsg) {
              store.dispatch('chatContact/resetCustomerUnseenMsgs', {customerId, instanceId})
            }

            commit('CHANGE_CONTACT_LAST_MESSAGE', {
              id: customerLastChat.id,
              type: customerLastChat.type, // Sent by attendant
              sent_at: customerLastChat.sent_at,
              message: customerLastChat.message,
              tag_type: customerLastChat.tag_type,
              document_name: customerLastChat.document_name,
              document_mimetype: customerLastChat.document_mimetype,
            })
          }

          resolve(customerChats)
        }
      })
          .catch((error) => {
            reject(error)
          })
    })
  },
  sendChatMessage({commit}, {customerId, toNumber, message, instanceId, userId, replyMessageId, hash, timeout}) {
    // Should remove loading overlay from requests made in chat attendance screen
    store.dispatch('setShowLoadingOverlay', false)
    timeout = timeout ? (timeout * 1000) : 0;

    /**
     * Adds the message below the last message to gives the user the "message sent instantly" impression,
     * even though the message was not completely sent yet
     */
    commit('APPEND_LAST_SENT_MESSAGE_TEMPORARILY', {customerId, message: decodeFromBase64(message)})

    return new Promise((resolve, reject) => {
      chatContact.sendChatMessage(toNumber, message, instanceId, userId, replyMessageId, hash, timeout).then(() => {
        // store.dispatch(
        //   'chatContact/fetchCustomerChats',
        //   {
        //     customerId,
        //     instanceId,
        //     unseenMsg: true,
        //     finishedTickets: false,
        //     keepTempMessage: true,
        //   }
        // ).then(() => {
        //   // setTimeout(() => {
        //   //   store.dispatch('chatContact/fetch', {
        //   //     instanceId,
        //   //     finishedTickets: false,
        //   //     searchQuery: ''
        //   //   }).then(response => {
        //   //     const customerIndex = response.data.data.customers.items.findIndex((c) => c.id === customerId)
        //   //     resolve(response.data.data.customers.items[customerIndex])
        //   //   })
        //   // }, 2000)
        // })
      })
          .catch((error) => {
            store.dispatch('setShowLoadingOverlay', true)
            reject(error)
          })
    })
  },
  sendChatImage({ commit }, { customerId, toNumber, imageUrl, fileName, instanceId, userId, hash, imageCaption, timeout }) {
    timeout = timeout ? (timeout * 1000) : 0;

    return new Promise((resolve, reject) => {
      chatContact.sendChatImage(toNumber, imageUrl, fileName, instanceId, userId, hash, imageCaption, timeout).then(response => {
        // commit('APPEND_LAST_SENT_MESSAGE_TEMPORARILY', {
        //   message: imageUrl,
        //   docName: imageCaption,
        //   isDoc: true,
        //   customerId
        // })
        // store.dispatch('chatContact/fetch', {
        //   instanceId,
        //   finishedTickets: false,
        //   searchQuery: ''
        // })
        // store.dispatch(
        //   'chatContact/fetchCustomerChats',
        //   {
        //     customerId,
        //     instanceId,
        //     unseenMsg: true,
        //     keepTempMessage: true,
        //     finishedTickets: false
        //   }
        // )
        resolve(response)
      })
          .catch((error) => {
            reject(error)
          })
    })
  },
  sendChatAudio({ commit }, { customerId, toNumber, fileUrl, fileCaption, instanceId, userId, hash, timeout, replyMessageId}) {
    timeout = timeout ? (timeout * 1000) : 0;

    return new Promise((resolve, reject) => {
      chatContact.sendChatAudio(toNumber, fileUrl, fileCaption, instanceId, userId, hash, timeout, replyMessageId)
        .then(response => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  sendChatComment({ commit }, { customerId, toNumber, message, instanceId, hash, timeout }) {
    // Should remove loading overlay from requests made in chat attendance screen
    store.dispatch('setShowLoadingOverlay', false)
    timeout = timeout ? (timeout * 1000) : 0;

    /**
     * Adds the message below the last message to gives the user the "message sent instantly" impression,
     * even though the message was not completely sent yet
     */
    commit('APPEND_LAST_SENT_MESSAGE_TEMPORARILY', { customerId, message: decodeFromBase64(message) })

    return new Promise((resolve, reject) => {
      chatContact.sendChatComment(toNumber, message, instanceId, hash)
      .then((response) => { resolve(response) })
      .catch((error) => { reject(error) })
    })
  },
  sendChatSticker({ commit }, { customerId, toNumber, imageUrl, instanceId, userId, hash, timeout }) {
    timeout = timeout ? (timeout * 1000) : 0;

    return new Promise((resolve, reject) => {
      chatContact.sendChatSticker(toNumber, imageUrl, instanceId, userId, hash, timeout)
        .then(response => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  sendReactionToMessage({ commit }, { reaction, customerChatId, instanceId }) {
    return new Promise((resolve, reject) => {
      chatContact.sendReactionToMessage(reaction, customerChatId, instanceId)
        .then(response => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  appendTransferredChat({ commit }, transferredChat) {
    commit('APPEND_TRANSFERRED_CHAT', transferredChat)
  },
  clearTransferredChats({commit}) {
    commit('CLEAR_TRANSFERRED_CHATS')
  },
  socketListeners({commit, state}) {
    if ( !state.isSocketAlreadyListened ) {
      // Socket - Muda a última mensagem enviada pelo contato na sidebar do chat

      // Abrir modal quando um novo chat.ticket.transfer for criado para que o atendente 
      // requisitado possa aceitar ou rescusar a transferencia de atendimento
      Vue.$events.on('ChatTicketTransfer', ({
        ticketTransfer,
        instanceId,
        tenantName
      }) => {
        if ( tenantName === getCurrentTenant() ) {
          if ( store.getters["instance/chosenInstanceIds"].includes(instanceId) ) {
            if (ticketTransfer.previous_user_id === store.state.AppActiveUser.id) {
              Vue.$events.$emit('ChatTicketTransferTimer', ticketTransfer)
            }
            Vue.$events.$emit('ChatTicketTransferReloadChatTickets')
          } else if (ticketTransfer.previous_user_id === store.state.AppActiveUser.id) {
            Vue.$events.$emit('ChatTicketTransferTimerAllPages', ticketTransfer)
          }
        }
      });

/*
      Vue.$events.on('CustomerChatCreated', async ({
         customerChat,
         tenantName,
         finishChatTicket,
         inbox = false,
         inboxDepartmentId = null,
         olderInboxChatsFirst = false
       }) => {
        if (
            tenantName === getCurrentTenant() &&
            customerChat.instance_id === store.state.instance.selectedInstance
        ) {
          // Should remove loading overlay from requests made in chat attendance screen
          if (!finishChatTicket) {
            store.dispatch('setShowLoadingOverlay', false)
          }

          const {
            AppActiveUser: activeUser,
            chatContact: contact
          } = store.state;

          if (customerChat.customer_id === store.state.chatContact.selectedCustomerChats.customerId) {
            customerChats.fetch(customerChat.customer_id, customerChat.instance_id)
          }

          const shouldPutContactAtTop = !inbox
              && contact.chatTab === 'my_chats';

          let belongsToDepartment;

          if (!activeUser.userDepartment) {
            belongsToDepartment = !inboxDepartmentId
                || activeUser.role.name === 'administrador'
          } else {
            belongsToDepartment = !inboxDepartmentId
                || inboxDepartmentId === activeUser.userDepartment.id
                || activeUser.role.name === 'administrador'
          }

          const shouldPutContactAtInboxTop = inbox
              && contact.chatTab === 'inbox'
              && belongsToDepartment;

          const shoulChangeInboxSatatus = inbox
              && contact.chatTab !== 'inbox';

          chatContact.fetch(
              [customerChat.instance_id],
              false,
              '',
              false,
              1,
              1,
              customerChat.customer_id,
              inbox
          ).then((response) => {
            store.dispatch('setShowLoadingOverlay', true)

            if (
                contact.chatFilter === 'campaign' &&
                response.data.data.chatTickets.items.length > 0 &&
                (shouldPutContactAtTop || shouldPutContactAtInboxTop) &&
                (
                    response.data.data.chatTickets.items[0].campaign_id !== null &&
                    response.data.data.chatTickets.items[0].campaign.name != "Resposta passiva"
                )
            ) {
              if (response.data.data.chatTickets.items[0].customerLastChat.is_bot_message === true) {
                // Adiciona o atendimento no topo dinamicamente se 'Campanha' estiver ativa
                commit('PUT_CONTACT_AT_THE_TOP', {
                  chatContact: response.data.data.chatTickets.items[0],
                  inbox,
                  olderInboxChatsFirst,
                  isAdminUser: activeUser.role.name === 'administrador'
                })
              } else if (response.data.data.chatTickets.items[0].customerLastChat.is_bot_message === false) {
                // Remove o atendimento da listagem de 'Campanha' porque houve uma resposta humana
                commit('REMOVE_CHAT_CONTACT', {
                  chatFilter: contact.chatFilter,
                  chatContact: response.data.data.chatTickets.items[0]
                })
              }
            }

            // Adiciona o atendimento no topo dinamicamente se 'Atendimento' estiver ativa
            else if (
                contact.chatFilter === 'attendance' &&
                response.data.data.chatTickets.items.length > 0 &&
                (shouldPutContactAtTop || shouldPutContactAtInboxTop) &&
                (
                    response.data.data.chatTickets.items[0].campaign == null ||
                    response.data.data.chatTickets.items[0].campaign.name == "Resposta passiva" ||
                    response.data.data.chatTickets.items[0].customerLastChat.is_bot_message === false
                )
            ) {
              commit('PUT_CONTACT_AT_THE_TOP', {
                chatContact: response.data.data.chatTickets.items[0],
                inbox,
                olderInboxChatsFirst,
                isAdminUser: activeUser.role.name === 'administrador'
              })
            }

            // Adiciona o atendimento no topo dinamicamente se 'Todos' estiver ativo
            else if (
                contact.chatFilter === 'all' &&
                response.data.data.chatTickets.items.length > 0 &&
                (shouldPutContactAtTop || shouldPutContactAtInboxTop)
            ) {
              commit('PUT_CONTACT_AT_THE_TOP', {
                chatContact: response.data.data.chatTickets.items[0],
                inbox,
                olderInboxChatsFirst,
                isAdminUser: activeUser.role.name === 'administrador'
              })
            }

            if (
                response.data.data.chatTickets.items.length > 0 &&
                shoulChangeInboxSatatus
            ) {
              commit('INBOX_MESSAGING_STATUS', 'unseen');
            }
          }).catch(() => {
            store.dispatch('setShowLoadingOverlay', true)
          })
        }
      });
*/

      Vue.$events.on('CustomerChatAckChanged', ({customerChat, tenantName}) => {
        if (
            tenantName === getCurrentTenant() &&
            store.getters["instance/chosenInstanceIds"].includes(customerChat.instance_id)
        ) { commit('CHANGE_CUSTOMER_CHAT_ACK', customerChat); }
      });

      Vue.$events.on('UpdateWhatsappStatus', () => {
        store.dispatch("updateWhatsappStatus");
      });

      Vue.$events.on('UpdateMaintenanceStatus', () => {
        store.dispatch("updateMaintenanceStatus");
      });

      // Socket - Faz o barulho da notificação e joga o chat para primeiro da listagem na sidebar
      Vue.$events.on('ChatNotification', ({
        customerId,
        instanceId,
        tenantName,
        attendantId,
        customerName,
        message,
        inbox = false,
        olderInboxChatsFirst = false,
        inbox_department_id = 0,
        instanceName = ''
      }) => {
        const {AppActiveUser} = store.state;

        if (
          tenantName === getCurrentTenant() &&
          store.state.instance !== undefined &&
          store.getters["instance/chosenInstanceIds"].includes(instanceId) &&
          ( AppActiveUser.id === attendantId || (
            attendantId === null && (
              ( AppActiveUser.role.name === 'administrador' || !inbox_department_id ) ||
              ( inbox_department_id && AppActiveUser.userDepartment && AppActiveUser.userDepartment.id === inbox_department_id )
          )))
        ) {
          commit('CHAT_NOTIFICATION', {
            customerId,
            inbox,
            olderInboxChatsFirst
          })
        }

        if (
          tenantName === getCurrentTenant() &&
          store.state.instance !== undefined &&
          store.getters["instance/chosenInstanceIds"].includes(instanceId) &&
          ( AppActiveUser.id === attendantId || (
            attendantId === null && (
              ( AppActiveUser.role.name === 'administrador' || !inbox_department_id ) ||
              ( inbox_department_id && AppActiveUser.userDepartment && AppActiveUser.userDepartment.id === inbox_department_id )
          )))
        ) {
          if (Notification) {
            if (Notification.permission !== 'denied') {
              Notification.requestPermission();
            }
          } else { console.error('O browser não suporta notificações desktop'); }

          if (Notification.permission !== 'granted') {
            Notification.requestPermission();
          } else {
            const date = new Date;

            const currentHourAndMinutes = `${
              date.getHours() < 10 ? '' + date.getHours() : date.getHours()
            }:${
              date.getMinutes() < 10 ? '' + date.getMinutes() : date.getMinutes()
            }`;

            var notification = new Notification(customerName, {
              body: `${/^{"orderId":"\d{15}","itemCount":\d,"orderTitle":"[a-zA-Z\s,]+","amount":\d+}$/.test(message) ? 'Você recebeu um pedido via catálogo!' : message} - ${currentHourAndMinutes} (Conexão: ${instanceName})`,
            });

            notification.onclick = function () {
              router.push(formatRouteTenantPath(`/instances/list/choose-instance`));
            };
          }
        }

        if (
          inbox === true
          && tenantName === getCurrentTenant()
          && store.state.instance !== undefined
          && store.state.chatContact.chatTab !== 'inbox'
          && store.getters["instance/chosenInstanceIds"].includes(instanceId)
          && (
            AppActiveUser.role.name === 'administrador'
            || inbox_department_id === 0
            || getUserDepartment() === inbox_department_id
        )) { commit('INBOX_MESSAGING_STATUS', 'unseen'); }
      });

      // Socket - Caso seja um contato não cadastrado no sistema, cria uma linha de chat na sidebar
      Vue.$events.on('CustomerCreatedToChat', ({
        customer,
        instanceId,
        tenantName,
        inbox = false,
        olderInboxChatsFirst = false
      }) => {
        if (
          tenantName === getCurrentTenant()
          && customer.customerLastChat !== null
          && store.getters["instance/chosenInstanceIds"].includes(instanceId)
          && (
            ( inbox && store.state.chatContact.chatTab === 'inbox' ) ||
            ( !inbox && store.state.chatContact.chatTab === 'my_chats' )
        )) {
          commit('CONCAT_CHAT_CONTACT', {
            customer,
            inbox,
            olderInboxChatsFirst
          })
        }

        if (
          inbox &&
          tenantName === getCurrentTenant() &&
          store.state.chatContact.chatTab !== 'inbox' &&
          store.getters["instance/chosenInstanceIds"].includes(instanceId)
        ) { commit('INBOX_MESSAGING_STATUS', 'unseen'); }
      });

      // Socket - Caso seja um contato não cadastrado no sistema, cria uma linha de chat na sidebar
      Vue.$events.on('CustomerBlacklisted', ({customerId, tenantName}) => {
        if (tenantName === getCurrentTenant()) {
          commit('CUSTOMER_BLACKLISTED', customerId)
        }
      });

      // Socket - Aparece uma notificação para o atendente que possuía o chat_ticket atrelado à ele
      // no caso que o ADMIN tenha feito o encerramento do atendimento
      // Vue.$events.on('ChatTicketClosed', (
      //   { chatTicket, triggerUserId, tenantName, instanceId, isFinishingWithoutMessenger, isAdmin }
      // ) => {
      //     const { AppActiveUser } = store.state
      //     if (
      //       tenantName === getCurrentTenant() &&
      //       store.state.instance.selectedInstance === instanceId
      //     ) {
      //       store.dispatch('setShowLoadingOverlay', false)
      //       store.dispatch('chatContact/fetch', {
      //         instanceId: instanceId,
      //         searchQuery: '',
      //         finishedTickets: false
      //       })
      //       .then(() => { store.dispatch('setShowLoadingOverlay', true) })
      //       .catch(() => { store.dispatch('setShowLoadingOverlay', true) })

      //       if (chatTicket.customer_id === store.state.chatContact.selectedCustomerChats.customerId) {
      //         commit('CHANGE_SELECTED_CUSTOMER', { customerId: null })
      //       }
      //     }
      //   });

      // Socket - Aparece uma notificação para o atendente que possuía o chat_ticket atrelado à ele
      // no caso que o ADMIN tenha feito o encerramento do atendimento
      Vue.$events.on('ChatTicketTransferred', ({
        chatTicket,
        triggerUserId,
        triggerUserName,
        instanceId,
        instanceName,
        tenantName,
        inbox = false
      }) => {
        store.dispatch('setShowLoadingOverlay', false)
        Vue.$events.fire('ChatTicketTransferredDropDown', {
          chatTicket,
          triggerUserId,
          triggerUserName,
          instanceId,
          instanceName,
          tenantName
        })
        Vue.$events.fire('ChatTicketTransferredReloadChatTickets', {
          chatTicket,
          triggerUserId,
          triggerUserName,
          instanceId,
          instanceName,
          tenantName,
          inbox
        })
      });

      commit('SOCKET_WAS_LISTENED')
    }
  },
  resetCustomersToRemoveIds({commit}) {
    commit('RESET_CUSTOMERS_TO_REMOVE_IDS')
  },
  initInboxMessaging({commit}, instanceIds) {
    return new Promise((resolve, reject) => {
      chatContact.fetch(
          instanceIds,
          false,
          '',
          true,
          1,
          1,
          undefined,
          true
      ).then(response => {
        const status = response.data.data.chatTickets.items.length > 0 ? 'unseen' : 'seen';
        commit('INBOX_MESSAGING_STATUS', status)
      }).catch((error) => { reject(error) })
    })
  },
  setInboxMessagesStatus({commit}, status = 'seen') {
    commit('INBOX_MESSAGING_STATUS', status);
  },
  setChatTab({commit}, tab = 'my_chats') {
    commit('CHAT_TAB', tab);
  },
  setChatContactDropdown({commit}, chatContact) {
    commit('SET_CHAT_CONTACT_DROPDOWN', chatContact);
  },
  changeStatusAttendancePopupActive({commit}, status) {
    commit('SET_STATUS_ATTENDANCE_POPUP', status);
  },
  setChatPickingPopup({commit}, chatContact) {
    commit('SET_CHAT_PICKING_POPUP', chatContact);
  },
  changeStatusPickingPopupActive({commit}, status) {
    commit('SET_STATUS_PICKING_POPUP', status);
  },
  setChatFinalizePopup({commit}, chatContact) {
    commit('SET_CHAT_FINALIZE_POPUP', chatContact);
  },
  changeStatusFinalizePopupActive({commit}, status) {
    commit('SET_STATUS_FINALIZE_POPUP', status);
  },
  setChatTransferPopup({commit}, chatContact) {
    commit('SET_CHAT_TRANSFER_POPUP', chatContact);
  },
  changeStatusTransferPopupActive({commit}, status) {
    commit('SET_STATUS_TRANSFER_POPUP', status);
  },
  setChatFilter({commit}, filter = 'all') {
    commit('CHAT_FILTER', filter)
  },
  setAdditionalChatOrigin({commit}, filter = null) {
    commit('ADDITIONAL_CHAT_FILTER', filter)
  },
  setGroupsSelectedFilter({commit}, groupIds = []) {
    commit('GROUPS_SELECTED_FILTER', groupIds)
  },
  getInStorageGroupsSelectedFilter({commit}) {
    commit('GET_IN_STORAGE_GROUPS_SELECTED_FILTER')
  }
}
